import { useId, useState } from "react";
import { LlmLogsPanel } from "./LlmLogsPanel.js";
import { LlmUsageDashboard } from "./LlmUsageDashboard.js";
import { SystemLogsPanel } from "./SystemLogsPanel.js";
import { SegmentedControl, segPanelId, segTabId } from "./ui/SegmentedControl";

type SubTab = "llm" | "usage" | "system";

type Props = {
  setErr: (e: string | null) => void;
};

export function AdminLogsPanel({ setErr }: Props) {
  const [subTab, setSubTab] = useState<SubTab>("llm");
  // Rdzeń identyfikatorów wiążących podzakładkę z jej treścią - patrz segTabId/segPanelId.
  const tabIdBase = useId();

  return (
    <div className="admin-logs-panel">
      <SegmentedControl
        idBase={tabIdBase}
        ariaLabel="Rodzaj logów"
        value={subTab}
        onChange={(v) => setSubTab(v as SubTab)}
        options={[
          { value: "llm", label: "Logi zapytań LLM" },
          { value: "usage", label: "Zużycie i koszty" },
          { value: "system", label: "Logi systemowe" },
        ]}
      />
      {/* Naraz renderuje się dokładnie jedna podzakładka, więc jeden wspólny panel wystarczy -
          jego tożsamość jedzie za wybraną podzakładką. */}
      <div
        role="tabpanel"
        id={segPanelId(tabIdBase, subTab)}
        aria-labelledby={segTabId(tabIdBase, subTab)}
      >
        {subTab === "llm" ? <LlmLogsPanel setErr={setErr} /> : null}
        {subTab === "usage" ? <LlmUsageDashboard setErr={setErr} /> : null}
        {subTab === "system" ? <SystemLogsPanel setErr={setErr} /> : null}
      </div>
    </div>
  );
}
